// Images de présentation du site (hero, sections) + coordonnées officielles 3M Match Pro
export const IMAGES = {
  heroHome: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?q=80&w=1920&auto=format&fit=crop",
  stadiumAerial: "https://images.unsplash.com/photo-1517747614396-d21a78b850e8?q=80&w=1600&auto=format&fit=crop",
  training: "https://images.unsplash.com/photo-1598880513655-d1c6d4b2dfbf?q=80&w=1400&auto=format&fit=crop",
  matchAction: "https://images.pexels.com/photos/29719215/pexels-photo-29719215.jpeg?auto=compress&cs=tinysrgb&w=1600",
  jersey: "https://images.unsplash.com/photo-1689624291789-7b402a15915a?q=80&w=1400&auto=format&fit=crop",
  goal: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?q=80&w=1400&auto=format&fit=crop",
  ball: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?q=80&w=1400&auto=format&fit=crop",
  pitch: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?q=80&w=1400&auto=format&fit=crop",
  boots: "https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?q=80&w=1400&auto=format&fit=crop",
  aerial: "https://images.unsplash.com/photo-1459865264687-595d652de67e?q=80&w=1400&auto=format&fit=crop",
  cones: "https://images.unsplash.com/photo-1526232761682-d26e03ac148e?q=80&w=1400&auto=format&fit=crop",
  night: "https://images.unsplash.com/photo-1553778263-73a83bab9b0c?q=80&w=1400&auto=format&fit=crop",
  action: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?q=80&w=1400&auto=format&fit=crop",
};

export const CONTACT_INFO = {
  email: "3m.matchpro.ks@gmail.com",
  telephones: [
    { name: "Sylvain", number: "06 84 11 87 42" },
    { name: "Kader", number: "06 33 38 67 45" },
  ],
  instagram: "https://www.instagram.com/3m.matchpro/",
  zone: "Côte d'Azur — France",
};
